import { Fragment, ReactNode } from 'react';

export interface IfProps {
  isTrue: boolean;
  children?: ReactNode;
}

export const If = (props: IfProps) => {
  if (!props.isTrue) return null;
  return <Fragment>{props.children}</Fragment>;
};
